export interface PDFViewerProps extends React.HTMLAttributes<HTMLIFrameElement> {
  src: string;
}

export const PDFViewer = ({ src, ...props }: PDFViewerProps) => {
  return <iframe src={src} {...props} allowFullScreen={false} />;
};
